<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled }" @click="openModal" style="width: 55px;">
            {{ car.bill_of_landing ? formatDate(car.bill_of_landing) : '---' }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Bill of landing:</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <article v-if="error.status" class="message is-danger">
                        <div class="message-body">
                            <strong>{{ error.message }}!</strong>
                        </div>
                    </article>
                    <article v-if="success" class="message is-success">
                        <div class="message-body">
                            <strong>Success!</strong> File was uploaded!
                        </div>
                    </article>
                    <div class="field">
                        <datetime
                                input-class="input"
                                v-model="carData.query.bill_of_landing"
                                :format="dateFormat"
                                type="date"
                                value-zone="local"
                                zone="local"
                                :input-id="carData.id.toString()"
                                placeholder="Select date"
                        ></datetime>
                    </div>
                    <div class="field">
                        <input
                            class="input"
                            v-model="carData.query.bill_of_landing_number"
                            type="text"
                            placeholder="Type B/L number"
                        >
                    </div>
                    <div class="field">
                        <div class="file has-name is-boxed">
                            <label class="file-label">
                                <input class="file-input" ref="file" v-on:change="handleFileUpload()" type="file">
                                <span class="file-cta">
                                  <span class="file-icon">
                                    <i class="fas fa-upload"></i>
                                  </span>
                                  <span class="file-label">
                                    Choose a file…
                                  </span>
                                </span>
                                <span class="file-name">
                                  {{ fileName }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <p v-if="noFiles" class="text-centered">No Files</p>
                    <div v-for="element in uploadedDocument"  @dblclick="selectFile(element)" :class="{'is-focused': isSelected(element)}" class="button select-image">
                        {{ element.split("/").pop() }}
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive" :class="{ 'is-loading': isLoading }">Close</button>
                    <button class="button is-primary"  @click="saveChanges" :class="{ 'is-loading': isLoading }">Save</button>
                    <button class="button" @click="showUploadedFiles" :class="{ 'is-loading': isLoading }">Show Uploaded Files</button>
                    <button class="button is-danger" v-if="readyToDelete" @click="deleteSelectedFiles" :class="{ 'is-loading': isLoading }"><i class="fas fa-trash-alt"></i></button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import moment from 'moment-timezone'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                dateFormat: null,
                isActive: false,
                success: false,
                documents: null,
                fileName: 'Only PDF file.',
                error: {
                    status: false,
                    message: []
                },
                carData:{
                    id: this.car.id,
                    query: {
                        bill_of_landing: this.car.bill_of_landing,
                        bill_of_landing_number: this.car.bill_of_landing_number,
                    }
                },
                uploadedDocument: null,
                selectedFiles: [],
                noFiles: false,
                mediaLoaded:false,
                isLoading: false,
            }
        },
        methods: {
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            openModal() {
                this.success = false
                this.isActive = !this.isActive
            },
            handleFileUpload(){
                this.documents = this.$refs.file.files[0];
                this.fileName = this.$refs.file.files[0].name;
            },
            saveChanges() {
                this.isLoading = true
                this.success = false
                if (this.documents !== null) {
                    let formData = new FormData();

                    formData.append('bill', this.documents);
                    formData.append('car_id',  this.car.id);

                    apiCars
                        .carsUploadDocumentsRequest(formData)
                        .then((response) => {
                            this.isLoading = false
                            this.success = true
                            this.fileName = 'Only PDF file.'
                        })
                        .catch(error => {
                            console.log(error)
                            this.isLoading = false
                            if ( error.response && error.response.status === 422 ) {
                                this.error.status = true
                                this.error.message = 'The documents must be a file of type: pdf.'
                            }
                        })
                }
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.bill_of_landing = this.carData.query.bill_of_landing
                        this.car.bill_of_landing_number = this.carData.query.bill_of_landing_number
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            },
            showUploadedFiles() {
                apiCars
                    .getCarDocumentsRequest(this.car.id)
                    .then((response) => {
                        this.mediaLoaded = true
                        this.uploadedDocument = response.data.bill_of_landings
                        this.noFiles = response.data.bill_of_landings === null
                    })
                    .catch(error => console.log(error))
            },
            selectFile(file) {
                if (this.selectedFiles.includes(file)) {
                    this.selectedFiles = this.selectedFiles.filter(item => item !== file)

                } else {
                    this.selectedFiles.push(file)
                }
            },
            deleteSelectedFiles() {
                this.error.status = false
                this.isLoading = true
                this.success = false
                let query = {
                    media: this.selectedFiles
                }
                apiCars
                    .deleteCarMediaFilesRequest(query)
                    .then((response) => {
                        this.isLoading = false
                        this.selectedFiles = []
                        this.showUploadedFiles()
                    })
                    .catch(error => {
                        this.selectedFiles = []
                        this.isLoading = false
                        console.log(error)

                    })
            },
            isSelected(file) {
                return this.selectedFiles.includes(file)
            },
        },
        computed: {
            isFilled() {
                if (this.formatDate(this.carData.query.bill_of_landing) !== '---'){
                    return  true;
                }
            },
            readyToDelete() {
                return this.selectedFiles.length > 0
            },
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/BillOfLandingColumn.vue